import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import TabsComponent from "../common/tabs";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";
import {useSelector} from "react-redux";
import {GTMScreenView} from "../../../src/analytics/GoogleTagManager";
import SearchErrorHandler from "../common/search-error-handler";
import { useTranslation } from "react-i18next";
import {CT_Events} from "../../../src/analytics/CTEvents";

const PassportCountriesTabs = ({ pmsitem }) => {
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [content, setContent] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredContent, setFilteredContent] = useState([]);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const { t } = useTranslation()
  const {CT_ScreenView} = CT_Events();
  const {
    data: { data } = {},
    isLoading,
    isFetching,
    error,
    isError,
    isLoadingError,
    isSuccess,
  } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}], {
    retry: false,
    retryOnMount: false,
  });

  useEffect(() =>{
    try{
      GTMScreenView("Passport_Countries", msisdn, logintype );
    }catch{}
    try{
      CT_ScreenView()
    }catch{}
  }, [])
  useEffect(() => {
    if (isSuccess) {
      if (search?.length) {
        const _content = JSON.parse(JSON.stringify(content))
        const result = _content
          ?.filter(
            (item) =>
              item?.data?.filter((item2) =>
                item2?.country?.toLowerCase()?.includes(search)
              )?.length
          )
          ?.map((item, index) => {
            item.data = item?.data?.filter((item2) =>
              item2?.country?.toLowerCase()?.includes(search)
            );
            return item;
          });
        const result2 = categories?.filter(
          (item) => result?.filter((item2) => item2?.id === item?.id)?.length
        );
        setFilteredCategories(result2);
        setFilteredContent(result);
      } else {
        setCategories(data?.response?.category);
        setContent(data?.response?.data);
      }
    }
  }, [search, isSuccess]);
  useEffect(() => {
    // console.log(content);
  }, [content]);
  if (isLoading || isFetching) {
    return <Loadingcomponent message={"Loading"} />;
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={"Invalid"} />;
  }
  return (
    <div className="radius_section">
      <div className="flex_grp_align_center search_input_grp mt-3">
        <div className="input_icon_search left-icon flex1">
          <input
            type="text"
            value={search}
            maxLength={10}
            onChange={(e) => setSearch(e.target.value)}
            className="form-control"
            placeholder=""
          ></input>
          <button className="pe-none">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/search_dark.svg"}
              alt=""
              title=""
            />
          </button>
        </div>
        {/* <button className="filter_btn">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/fillter-icon.svg"}
            alt=""
            title=""
          />
          Filter
        </button> */}
      </div>
      {console.log(filteredContent, "filteredContentfilteredContent")}
      {(search ? (filteredContent.length > 1 ? <TabsComponent
        type={4}
        data={{
          category: search ? filteredCategories : categories,
          data: search ? filteredContent : content,
        }}
      ></TabsComponent> : <SearchErrorHandler text={t("wcf")} />) : <TabsComponent
        type={4}
        data={{
          category: search ? filteredCategories : categories,
          data: search ? filteredContent : content,
        }}
      ></TabsComponent>)}
    </div>
  );
};

export default PassportCountriesTabs;
